// Typelizer digest 5feb096ea6678b6f2d2c35781f3dd303
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /bank_statement_uploads/:bank_statement_upload_id/bank_account */
  update: (
    params: { bankStatementUploadId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/bank_statement_uploads/:bank_statement_upload_id/bank_account', params, options),
    method: 'patch',
  }),
}
